import React from 'react';

import { ConsumptionPageTypes } from 'src/types/consumption';

import { useAppStore } from 'src/hooks/useAppStore';
import * as customStyled from './styles';
import SupportedItems, { ValueObject } from './SupportedItems';
interface ContentSupportedDetailsProps
  extends ConsumptionPageTypes.CommonUIProps {
  audioLanguages: ValueObject[];
  subtitles: ValueObject[];
  genre: ValueObject[];
}

const ContentSupportedDetails: React.FC<ContentSupportedDetailsProps> = ({
  spaceX,
  spaceY,
  audioLanguages,
  subtitles,
  genre
}) => {
  const consumptionPageStrings = useAppStore()?.translations.consumption;
  return (
    <div
      css={customStyled.wrapper(spaceX as string, spaceY as string)}
      data-testid="content-supported-details">
      {audioLanguages?.length ? (
        <SupportedItems
          title={consumptionPageStrings?.AUDIO_LANG_INFO}
          values={audioLanguages}
        />
      ) : null}

      {subtitles?.length ? (
        <SupportedItems
          title={consumptionPageStrings?.SUBTITLES}
          values={subtitles}
        />
      ) : null}
      {genre?.length ? (
        <SupportedItems title={consumptionPageStrings?.GENRE} values={genre} />
      ) : null}
    </div>
  );
};

export default ContentSupportedDetails;
